import { useEffect, useMemo } from 'react';

import { FilterCategory } from 'config/constants';
import useAssetCategories from 'hooks/useAssetCategories';

export default function useAssetCategoriesOptions(currentFilterCategory: FilterCategory) {

    const { assetCategories, fetchAssetCategories, isFetchingAssetCategories } = useAssetCategories()

    const assetCategoriesOptions = useMemo(() => {
        return assetCategories?.items?.map(ac => ({
            label: ac.name,
            value: ac.id,
        }))
    }, [assetCategories])

    useEffect(() => {
        if (currentFilterCategory !== FilterCategory.assetCategory || assetCategories) return
        fetchAssetCategories()

    }, [assetCategories, currentFilterCategory,])

    return { assetCategoriesOptions, isLoadingAssetCategories: isFetchingAssetCategories }

}
